import { render, staticRenderFns } from "./Workflow.vue?vue&type=template&id=28787d4e&scoped=true&"
import script from "./Workflow.vue?vue&type=script&lang=js&"
export * from "./Workflow.vue?vue&type=script&lang=js&"
import style0 from "./Workflow.vue?vue&type=style&index=0&id=28787d4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28787d4e",
  null
  
)

export default component.exports